exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#atc-choosing-collection-on[data-v-dc99bec6]{position:absolute;bottom:12px;left:12px;width:calc(100% - 24px);max-height:180px;overflow-y:auto;background-color:#fff;z-index:3;border:0 solid rgba(0,0,0,.15);border-radius:.25rem;box-shadow:0 1rem 3rem rgba(0,0,0,.18);padding-top:10px;padding-bottom:10px;display:none}.atc-choose-collection-chevron[data-v-dc99bec6]{position:absolute;top:9px;right:12px}", ""]);

// exports
